<template>
  <div class="usuarios">
    <div class="mb-2" style="text-align: right">
      <v-btn color="cyan" small dark to="/atena/usuario/novo" class="rounded-sm font-weight-regular" width="90px">Novo</v-btn>
    </div>

    <FiltroTable ref="filtro" :options="optionsBusca" :quantidadeResultados="paginaTotal" @filtro="filtroRegistros" />

    <v-alert type="error" v-if="usuarios.length <= 0" value="true" dark class="mt-3 mb-3">
      <div>Nenhum usuário cadastrado!</div>
    </v-alert>
    <v-card v-else style="overflow-y: auto">
      <table class="table-siged">
        <thead>
          <tr>
            <th>Código</th>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Perfis</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="usuario in usuarios" :key="usuario.identificadorusuario">
            <td class="centro">{{ usuario.identificadorusuario }}</td>
            <td>{{ usuario.nomeusuario }}</td>
            <td>{{ usuario.emailusuario }}</td>
            <td class="centro">
              <v-tooltip bottom style="flex: 1">
                <template v-slot:activator="{on, attrs}">
                    <span v-bind="attrs" v-on="on">{{ usuario.user_perfis.length }}</span>
                </template>
                <span>
                  <div v-for="key in usuario.user_perfis" :key="key.id">
                    <i>{{ key.perfil.nomeperfil }}</i>
                  </div>
                </span>
              </v-tooltip>
            </td>
            <td class="centro">
              <v-btn icon title="Perfis" class="aulas-btn-acao" :to="{ path: `/atena/usuario/${usuario.identificadorusuario}/perfil` }">
                <v-icon class="btn-acoes-icon">group</v-icon>
              </v-btn>
              <v-btn icon title="Editar" class="aulas-btn-acao" :to="{ path: `/atena/usuario/${usuario.identificadorusuario}` }">
                <v-icon class="btn-acoes-icon">edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="quantidadePaginas > 1" class="table-siged-page" style="text-align: right">
        <v-pagination v-model="paginaAtual" :length="quantidadePaginas" total-visible="7" />
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import FiltroTable from '@/components/FiltroTable';

const AtenaUsuarioRepository = RepositoryFactory.get('atenaUsuario');

export default {
  name: 'Usuario',
  components: {
    FiltroTable,
  },
  data() {
    return {
      usuarios: [],
      paginaAtual: 1,
      paginaTotal: 0,
      filtroBusca: [],
      quantidadePaginas: 0,
      snackbar: false,
      submitText: '',
      optionsBusca: [
        { text: 'Nome', value: 'nomeusuario', type: "text" },
        { text: 'Código', value: 'identificadortela', type: "number" },
        { text: 'E-mail', value: 'emailusuario', type: "text" },
      ],
    };
  },
  watch: {
    paginaAtual() {
      this.reload();
    }
  },
  async beforeRouteEnter(to, from, next){
    const { data } = await AtenaUsuarioRepository.getListaUsuarios();

    next(vm => vm.reload(data));
  },
  methods: {
    async reload(data = null) {
      if(!data) {
        this.$Progress.start();
        const retorno = await AtenaUsuarioRepository.getListaUsuarios({ page: this.paginaAtual, ...this.filtroBusca });
        data = retorno.data;
      }
      this.paginaAtual = data.results.current_page;
      this.usuarios = data.results.data;
      this.quantidadePaginas = data.results.last_page;
      this.paginaTotal = data.results.total;

      this.$Progress.finish();
    },
    async filtroRegistros(data) {
      this.paginaAtual = 1;
      this.$refs.filtro.exibirFiltro = false;
      this.filtroBusca = data.filtro;
      await this.reload();
      this.$refs.filtro.exibirFiltro = data.exibir;
    },
  },
}
</script>

<style lang="scss">
.usuarios {
  margin: 0px 15px;

  .aulas-btn-acao {
    margin: 0px;
    color: #4e4e4e!important;
  }
}
</style>
